import data from './JuniorAcademy.yaml'
import { WithPage } from "../Components/PageSections/WithPage";

export default function JuniorAcademy() {

  return WithPage(data, 'junioracademy')

}
